import React from 'react'
import PropTypes from 'prop-types'

import { faFileDownload } from '@fortawesome/pro-light-svg-icons'

import {
  DashboardModuleListItem, DashboardModule, FormField, Link,
} from '@domain-group/suit-theme'

import CustomInvoiceListItem from './CustomInvoiceListItem'

const CustomInvoice = (props) => {
  const { providerPayload } = props

  const {
    callbacks: {
      editProviderCustomInvoice,
    },
    loading,
    provider: {
      details_colour,
      font_colour,
      font_light_colour,
      highlight_colour,
      invoice_pdf,
    },
  } = providerPayload

  const { file_name, original: fileUrl } = invoice_pdf || {}

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link onClick={() => editProviderCustomInvoice()} textProps={{ fontSize: 'small' }}>
          Manage
        </Link>
      )}
      loading={loading}
      title="Custom Invoice"
    >
      {!loading && (
        <>
          <FormField
            boxProps={{
              borderBottom: '1px dashed',
              borderColor: 'lineColor',
              padding: 'large',
            }}
            label="Invoice Colours"
          >
            <CustomInvoiceListItem colour={font_colour} text="Font Colour" />

            <CustomInvoiceListItem colour={details_colour} text="Details Colour" />

            <CustomInvoiceListItem colour={font_light_colour} text="Light Font Colour" />

            <CustomInvoiceListItem
              boxProps={{ paddingBottom: 'none' }}
              colour={highlight_colour}
              text="Highlight Colour"
            />
          </FormField>

          <FormField label="File" boxProps={{ padding: 'large' }}>
            <DashboardModuleListItem
              boxProps={{ padding: 'none', paddingTop: 'medium' }}
              isChecked={!!invoice_pdf}
              showCheckbox
              title={file_name || 'No Invoice PDF'}
            >
              <DashboardModuleListItem.Actions>
                <DashboardModuleListItem.Icon icon={faFileDownload} href={fileUrl} target="_blank" />
              </DashboardModuleListItem.Actions>
            </DashboardModuleListItem>
          </FormField>
        </>
      )}
    </DashboardModule>
  )
}

CustomInvoice.propTypes = {
  providerPayload: PropTypes.object,
}

export default CustomInvoice
